<template>
  <div class="login-password form">
    <div class="ipt-item">
      <customField
        v-model="form.account"
        :placeholder="$t('login.account_placeholder')"
      />
    </div>
    <div class="ipt-item">
      <custom-field
        :placeholder="$t('login.password_placeholder')"
        type="password"
        :open-eye-function="true"
        v-model="form.password"
        ref="custom-field-password"
      />
    </div>
    <div class="agreement-box">
      <Checkbox v-model="rememberPwd" shape="square">
        记住账号和密码
      </Checkbox>
    </div>
    <div
      class="btn-submit"
      :class="{ dis: submitDis }"
      @click="login"
    >
      {{ $t("common.confirm") }}
    </div>
    <!--  异常弹窗  -->
    <passwordErrorPrompt
      v-if="isShowLoginErrorPopup"
      :err-code="loginErrorData.errCode"
      :err-html="loginErrorData.data.err_msg.h5"
      @password-error-prompt-confirm="passwordErrorPromptConfirm"
      ref="password-error-prompt-el"
    />
  </div>
</template>

<script>
import customField from "@/components/customField/index.vue";
import passwordErrorPrompt from "@/components/passwordErrorPrompt.vue";
import { trimPlus } from "@/utils/utils.new";
import * as Sentry from "@sentry/vue";
import CryptoJS from "crypto-js";
import { Checkbox } from "vant";

export default {
  components: {
    Checkbox,
    customField,
    passwordErrorPrompt
  },
  props: {
    userInfo: {
      type: [Object, String],
      defaults: function() {
        return {};
      }
    }
  },
  watch: {
    userInfo: {
      handler(newVal) {
        if (newVal.account) {
          this.form.account = newVal.account;
        }
        if(newVal.password){
          this.rememberPwd = true;
          this.form.password = newVal.password;
        }
      },
      immediate: true
    }
  },
  computed: {
    submitDis() {
      return !(
        trimPlus(this.form.account) &&
        trimPlus(this.form.password)
      );
    }
  },
  data() {
    return {
      form: {
        account: "",
        password: "",
        login_type: "1"
      },
      isShowLoginErrorPopup: false, // 是否显示弹窗
      loginErrorData: "", // 登录异常数据
      rememberPwd: false,
    };
  },
  methods: {
    // 登录
    login() {
      this.form.account = trimPlus(this.form.account);
      this.form.password = trimPlus(this.form.password);
      if (!this.form.account || !this.form.password) {
        return;
      }
      this.$apis.authV2LoginApi(this.form).then(res => {
        const { code } = res;
        // 有code 即异常，非异常 res直接为 data中的数据，request问题
        if (code) {
          if (code === 100173 || code === 100174) {
            this.isShowLoginErrorPopup = true;
            this.loginErrorData = res;
            return false;
          }
        } else {
          const { token, user_info } = res;
          if(this.rememberPwd){
            this.$localstorage.set("h5RememberPwd", {
              account: this.form.account,
              password: this.form.password,
              phone: user_info.phone,
              zone_code: user_info.zone_code
            });
            this.$localstorage.set("hhhhhrpd", {
              hhhhhrpda: this.encryptPassword(this.form.account),
              hhhhhrpdp: this.encryptPassword(this.form.password)
            });
          }else{
            this.$localstorage.set("h5RememberPwd", {
              account: this.form.account,
              phone: user_info.phone,
              zone_code: user_info.zone_code
            });
            this.$localstorage.set("hhhhhrpd", {
              hhhhhrpda: this.encryptPassword(this.form.account)
            });
          }
          try {
            // sentry监控，增加额外信息
            if (user_info.user_id) {
              this.addInfoToSentry({
                user_id: user_info.user_id
              });
            }
          } catch (err) {

          }
          this.$localstorage.set("h5userInfo", user_info);
          localStorage.setItem("token", token);
          // 登录成功
          this.$apis
            .accountList()
            .then(res => {
              this.$router.replace("/h5-page-account");
            })
            .catch(e => {
              
            });
        }
      });
    },
    // 异常弹窗确认
    passwordErrorPromptConfirm() {
      this.isShowLoginErrorPopup = false;
      if (this.loginErrorData.code === 100173) {
        this.form.password = "";
        this.$refs["custom-field-password"].setInputFocus();
      }
    },
    // 加密
    encryptPassword(password) {
      const key = CryptoJS.enc.Utf8.parse('hhhhhrpd-key'); // 替换为你的密钥
      const iv = CryptoJS.enc.Utf8.parse('hhhhhrpd-iv'); // 替换为你的IV
      const encrypted = CryptoJS.AES.encrypt(password, key, { iv });

      return encrypted.toString();
    },
    // 解密
    decryptPassword(encryptedPassword) {
      const key = CryptoJS.enc.Utf8.parse('hhhhhrpd-key'); // 替换为你的密钥
      const iv = CryptoJS.enc.Utf8.parse('hhhhhrpd-iv'); // 替换为你的IV
      const decrypted = CryptoJS.AES.decrypt(encryptedPassword, key, { iv });

      return decrypted.toString(CryptoJS.enc.Utf8);
    },
    // 上报
    addInfoToSentry(infoObj = {}) {
      Sentry.configureScope(scope => {
        scope.setUser(infoObj);
      });
    }
  }
};
</script>

<style scoped lang="less">
@import "./form.comon.less";
</style>
